<li ngbDropdown class="nav-item dropdown-cart mr-25">
  <a class="nav-link" tabindex="0" ngbDropdownToggle id="navbarCartDropdown">
    <span [data-feather]="'clock'" [class]="'ficon'"></span>
    <span class="badge badge-pill badge-danger badge-up cart-item-count">{{ countdownText }}</span>
  </a>
</li>
